/* eslint-disable import/prefer-default-export */
import { track } from '../instrumentation/Track';

export const trackTerminalPrintRequest = (fields = {}) =>
  track('track_terminal_print_request', fields);

export const trackTerminalPrintSuccess = (fields = {}) =>
  track('track_terminal_print_success', fields);

export const trackTerminalPrintFailure = (fields = {}) =>
  track('track_terminal_print_failure', fields);
